var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32874 11.9231C3.34495 11.9513 3.36116 11.9771 3.37659 12.0053C3.39203 12.0327 3.40592 12.0608 3.42213 12.089C6.28796 17.1608 11.237 20.1448 12.1539 18.5851L13.3124 16.3563C13.4089 16.1662 13.3927 15.9338 13.2715 15.7185C13.27 15.7162 13.2623 15.7092 13.2592 15.7045C13.0979 15.3844 12.9504 15.3742 12.1037 14.8069C11.6646 14.4719 11.1968 14.108 10.8881 13.8333C10.5886 13.5688 10.1603 13.5532 9.91481 13.7942L9.43782 14.2724C9.27496 14.4351 9.05113 14.5259 8.82343 14.5212C8.13727 14.5095 6.82361 12.6305 6.09191 11.4723C5.88506 11.1437 5.72066 10.8682 5.62572 10.6999C5.53156 10.5317 5.38028 10.2492 5.20507 9.90172C4.58992 8.67621 3.65523 6.57737 3.99175 5.97088C4.10289 5.76897 4.2943 5.6195 4.51428 5.55924L5.16185 5.38238C5.49065 5.28926 5.69364 4.90658 5.62032 4.5106C5.54313 4.10132 5.47058 3.50891 5.40729 2.95486C5.35326 1.92813 5.4181 1.79352 5.22823 1.49067C5.22668 1.48519 5.22437 1.47502 5.22282 1.47267C5.10087 1.25747 4.911 1.12678 4.70029 1.11426L2.21807 1C0.424323 1.0133 0.46523 6.8544 3.32874 11.9231Z",
    stroke: "#222222",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bcf09f120fceda7d86b9aa0c1a1f0d2c.svg";
export { ForwardRef as ReactComponent };